import '../../components/Main.scss';

const NotFoundPage = () => {
  return (
    <div className="mainContainerContent NotFoundPage">
      <div className="NotFoundPage">
        <span>404</span>
        <span>Ooops, page not found</span>
      </div>
    </div>
  );
};

export { NotFoundPage };
